export default [
  {
    path: '/pgt',
    name: 'PgtFinance',
    component: () => import('@/views/pgt/index.vue'),
    meta: {
      auth: true,
      title: 'LP挖矿',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]
